import axios from 'axios';

const baseRoute = process.env.REACT_APP_API_NOTIFICATIONS_ROUTE;

const withCredentials = { withCredentials: true };

class NotificationService {
    async getAll() {
        const response = await axios.get(baseRoute, withCredentials);
        return response.data;
    }

    async getUnreadCount() {
        const response = await axios.get(`${baseRoute}/unread-count`, withCredentials);
        return response.data.count;
    }

    async getLoginPopup() {
        const response = await axios.get(`${baseRoute}/login-popup`, withCredentials);
        return response.data;
    }

    async markAsRead(id) {
        await axios.patch(`${baseRoute}/${id}/read`, null, withCredentials);
    }

    async markAllAsRead() {
        await axios.patch(`${baseRoute}/read-all`, null, withCredentials);
    }
}

export const notificationService = new NotificationService();
